import React, { useState } from 'react';
import {
  FaTachometerAlt,
  FaMoneyBillWave,
  FaUsers,
  FaLayerGroup,
  FaExchangeAlt,
  FaReceipt,
  FaFileUpload,
  FaChevronRight,
  FaChevronDown,
  FaUser,
  FaBullseye,
  FaTicketAlt
} from 'react-icons/fa';
import { MdPhoneAndroid } from 'react-icons/md';

const Sidebar = ({ selectedView, onViewChange, userInfo, isSidebarOpen, toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const menuItems = [
    {
      name: 'Dashboard',
      icon: FaTachometerAlt,
    },
    {
      name: 'Targets',
      icon: FaBullseye,
    },
    {
      name: 'Revenue Collection',
      icon: FaMoneyBillWave,
    },
    {
      name: 'Traders',
      icon: FaUsers,

      dropdownItems: [
        {
          name: 'Traders',
          icon: FaUser,

        },
        {
          name: 'Upload Traders',
          icon: FaFileUpload,

        }
      ]
    },
    {
      name: 'Groups',
      icon: FaLayerGroup,

    },
    {
      name: 'Transactions',
      icon: FaExchangeAlt,

    },
    {
      name: 'Receipts',
      icon: FaReceipt,

    },
    {
      name: 'My Devices',
      icon: MdPhoneAndroid,

    },
    {
      name: 'Support',
      icon: FaTicketAlt,

    }
  ];

  // Detect screen width for responsive behavior
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      width: '280px',
      backgroundColor: '#1976d2',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
      position: isMobile ? 'fixed' : 'static',
      top: 0,
      left: 0,
      height: '100vh',
      zIndex: 1000,
      transform: isMobile ? (isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
      transition: 'transform 0.3s ease-in-out',
      ...(isMobile && {
        display: isSidebarOpen ? 'flex' : 'none'
      })
    }}>
      {/* Logo/Title Section */}
      <div style={{
        padding: '1.5rem',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center',
        position: 'relative'
      }}>
        {isMobile && (
          <button
            onClick={toggleSidebar}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '5px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            aria-label="Close sidebar"
          >
            ×
          </button>
        )}
        <h2 style={{
          margin: 0,
          fontSize: '1.2rem',
          fontWeight: '600',
          color: '#FFFFFFFF'
        }}>
          Field Officer Portal
        </h2>
        {userInfo && (
          <p style={{
            margin: '0.5rem 0 0 0',
            fontSize: '0.8rem',
            opacity: 0.7,
            color: userInfo.zone_id ? '#FFFFFFFF' : '#e74c3c'
          }}>
            {userInfo.zone_name || 'No Zone Assigned'}
          </p>
        )}
      </div>

      {/* Navigation Menu */}
      <nav style={{ flex: 1, padding: '1rem 0' }}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isSelected = selectedView === item.name;
          const isDropdownItemSelected = item.hasDropdown && item.dropdownItems?.some(dropdownItem => selectedView === dropdownItem.name);
          const showAsSelected = isSelected || isDropdownItemSelected;

          if (item.hasDropdown) {
            return (
              <div key={item.name}>
                {/* Main dropdown trigger */}
                <div
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    padding: '0.75rem 1.5rem',
                    cursor: 'pointer',
                    backgroundColor: showAsSelected ? 'rgba(255,255,255,0.1)' : 'transparent',
                    borderLeft: showAsSelected ? '4px solid #ffffff' : '4px solid transparent',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    position: 'relative'
                  }}
                  onMouseOver={(e) => {
                    if (!showAsSelected) {
                      e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!showAsSelected) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <Icon
                    size={18}
                    style={{
                      color: showAsSelected ? '#ffffff' : '#e3f2fd',
                      minWidth: '18px'
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontWeight: showAsSelected ? '600' : '400',
                      fontSize: '0.9rem',
                      color: showAsSelected ? '#FFFFFFFF' : '#FFFFFFFF'
                    }}>
                      {item.name}
                    </div>
                    <div style={{
                      fontSize: '0.75rem',
                      opacity: 0.7,
                      color: '#FFFFFFFF',
                      marginTop: '0.1rem'
                    }}>
                      {item.description}
                    </div>
                  </div>
                  {dropdownOpen ? (
                    <FaChevronDown
                      size={12}
                      style={{ color: showAsSelected ? '#ffffff' : '#e3f2fd' }}
                    />
                  ) : (
                    <FaChevronRight
                      size={12}
                      style={{ color: showAsSelected ? '#ffffff' : '#e3f2fd' }}
                    />
                  )}
                </div>

                {/* Dropdown items */}
                {dropdownOpen && (
                  <div style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}>
                    {item.dropdownItems.map((dropdownItem) => {
                      const DropdownIcon = dropdownItem.icon;
                      const isDropdownSelected = selectedView === dropdownItem.name;

                      return (
                        <div
                          key={dropdownItem.name}
                          onClick={() => {
                            onViewChange(dropdownItem.name);
                            setDropdownOpen(false);
                          }}
                          style={{
                            padding: '0.75rem 1.5rem 0.75rem 3rem',
                            cursor: 'pointer',
                            backgroundColor: isDropdownSelected ? 'rgba(255,255,255,0.15)' : 'transparent',
                            borderLeft: isDropdownSelected ? '4px solid #ffffff' : '4px solid transparent',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.75rem'
                          }}
                          onMouseOver={(e) => {
                            if (!isDropdownSelected) {
                              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)';
                            }
                          }}
                          onMouseOut={(e) => {
                            if (!isDropdownSelected) {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }
                          }}
                        >
                          <DropdownIcon
                            size={16}
                            style={{
                              color: isDropdownSelected ? '#ffffff' : '#FFFFFFFF',
                              minWidth: '16px'
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{
                              fontWeight: isDropdownSelected ? '600' : '400',
                              fontSize: '0.85rem',
                              color: isDropdownSelected ? '#FFFFFFFF' : '#FFFFFFFF'
                            }}>
                              {dropdownItem.name}
                            </div>
                            <div style={{
                              fontSize: '0.7rem',
                              opacity: 0.7,
                              color: '#FFFFFFFF',
                              marginTop: '0.1rem'
                            }}>
                              {dropdownItem.description}
                            </div>
                          </div>
                          {isDropdownSelected && (
                            <FaChevronRight
                              size={10}
                              style={{ color: '#ffffff' }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          } else {
            // Regular menu item (no dropdown)
            return (
              <div
                key={item.name}
                onClick={() => onViewChange(item.name)}
                style={{
                  padding: '0.75rem 1.5rem',
                  cursor: 'pointer',
                  backgroundColor: isSelected ? 'rgba(255,255,255,0.1)' : 'transparent',
                  borderLeft: isSelected ? '4px solid #ffffff' : '4px solid transparent',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  position: 'relative'
                }}
                onMouseOver={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <Icon
                  size={18}
                  style={{
                    color: isSelected ? '#ffffff' : '#FFFFFFFF',
                    minWidth: '18px'
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontWeight: isSelected ? '600' : '400',
                    fontSize: '0.9rem',
                    color: isSelected ? '#FFFFFFFF' : '#FFFFFFFF'
                  }}>
                    {item.name}
                  </div>
                  <div style={{
                    fontSize: '0.75rem',
                    opacity: 0.7,
                    color: '#FFFFFFFF',
                    marginTop: '0.1rem'
                  }}>
                    {item.description}
                  </div>
                </div>
                {isSelected && (
                  <FaChevronRight
                    size={12}
                    style={{ color: '#ffffff' }}
                  />
                )}
              </div>
            );
          }
        })}
      </nav>

      {/* Footer */}
      <div style={{
        padding: '1rem 1.5rem',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        fontSize: '0.75rem',
        opacity: 0.6,
        textAlign: 'center'
      }}>
        MMDA Revenue Collection System
        <br />
        Field Officer Portal v1.0
      </div>
    </div>
  );
};

export default Sidebar;
